import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from 'i18next';

import Card from '../../../atoms/Card/Card';
import Menu from '../../../atoms/Menu/Menu';
import RadioButton from '../../../atoms/RadioButton/RadioButton';
import { getFromLocalStorage, saveToLocalStorage } from '../../../Functions/LocalStorageUtils';

import styles from './LanguageSetting.module.scss';

const LanguageSetting: React.FC = () => {
    const locale = getFromLocalStorage('inels-locale');
    const { t } = useTranslation();
    const [language, setLanguage] = useState(locale || 'en');


    const languages: {label: string, shortcut: 'en' | 'cs' }[] = [
        {
            label: 'English',
            shortcut: 'en'
        },
        {
            label: 'Čeština',
            shortcut: 'cs'
        },
    ];

    const handleLocaleChange = (language: 'en' | 'cs') => {
        saveToLocalStorage('inels-locale', language);
        changeLanguage(language);
        setLanguage(language);
    };

    return (
        <div className={styles.Container}>
            <div>
                <h2 className={styles.Heading}>{t('settings.general_settings.heading')}</h2>
            </div>
            <Card width="36rem" padding="1.5rem">
                <Menu orientation="vertical">
                    {languages.map(({label, shortcut}) => (
                        <Menu.Item
                            key={shortcut}
                            variant="primary"
                            isactive={shortcut === language}
                            onClick={() => handleLocaleChange(shortcut)}
                        >
                            <Menu.ItemLeft>{label}</Menu.ItemLeft>
                            <Menu.ItemRight>
                                <RadioButton group={`settings_general_${shortcut}`} checked={shortcut === language} />
                            </Menu.ItemRight>
                        </Menu.Item>
                    ))}
                </Menu>
            </Card>
        </div>
    );
}

export default LanguageSetting;